import { render, staticRenderFns } from "./ContentFilter.Vue?vue&type=template&id=2c1fc8ba"
import script from "./ContentFilter.Vue?vue&type=script&lang=js"
export * from "./ContentFilter.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentFilter.Vue
// module id = 9
// module chunks = 0